<div class="main-layout">
    <header class="header">
        <hdtk-header></hdtk-header>
    </header>
    <main class="content">
        <router-outlet></router-outlet>
    </main>
</div>
